import { Component } from '@angular/core';

@Component({
  selector: 'app-create-purchase-order',
  template: ``,
  styleUrls: []
})
export class CreatePurchaseOrderComponent {

}
